class Platform {


	// We do DOM manipulations to change the HTML layout of the WordPress backend.
	// This results in flickering when the page is rendered, because elements are moved around.
	// Therefor we hide everything initially and show the page after everything is setup.

	hideContent() {
		// Elements are initially hidden with CSS styles
		// But notices are dynamically added and need a special treatment
		const adminNotices = document.querySelectorAll('.notice');
		// Hide all notices with transition
		adminNotices.forEach(function (adminNotice) {
			adminNotice.style.opacity = '0';
		});
	}

	// Organize header elements into a DIV container with class "wp-patched-header".
	// This makes it easier to apply CSS styles.

	patchAdminPageHeader() {
		const adminContent = document.querySelector('#wpbody-content');
		if (adminContent) {
			const adminWrapper = Array.from(adminContent.children).find(el => el.classList.contains('wrap'));
			if (adminWrapper) {
				// Create the new wp-patched-header DIV
				const newHeaderContainer = document.createElement('div');
				newHeaderContainer.classList.add('wp-patched-header');
				// The HR tag marks the end of the header.
				// Move all elements before this tag into the new DIV
				const headerEndMarker = adminContent.querySelector('.wp-header-end');
				if (headerEndMarker) {
					let currentElement = headerEndMarker.previousElementSibling;
					while (currentElement) {
						const element = currentElement.previousElementSibling;
						newHeaderContainer.insertBefore(currentElement, newHeaderContainer.firstChild);
						currentElement = element;
					}
				} else {
					// Fallback for the pages without a HR marker.
					// These pages start either a H1 or a H2 tag, so we just move this tag.
					const firstElement = adminWrapper.firstElementChild;
					if (firstElement && (firstElement.tagName === 'H1' || firstElement.tagName === 'H2')) {
						newHeaderContainer.appendChild(firstElement);
					}
				}
				// Insert new header at first position
				if (newHeaderContainer.hasChildNodes()) {
					adminWrapper.insertBefore(newHeaderContainer, adminWrapper.firstChild);
				}
			}
		}
	}

	// Organize elements beyond the header into a DIV container with class "wp-patched-subheader".
	// This makes it easier to apply CSS styles.

	patchAdminSubHeader() {
		const adminContent = document.querySelector('#wpbody-content');
		if (adminContent) {
			// The HR tag marks the end of the header.
			// Move all elements before this tag into the new DIV
			const subContainer = adminContent.querySelector('.subsubsub');
			const headerEndMarker = adminContent.querySelector('hr.wp-header-end');
			if (subContainer && headerEndMarker) {
				// Create the new wp-patched-subheader div
				const newSubHeaderContainer = document.createElement('div');
				newSubHeaderContainer.classList.add('wp-patched-subheader');
				// Append sub containers
				newSubHeaderContainer.appendChild(subContainer);
				// Insert new sub header after the new header
				headerEndMarker.insertAdjacentElement('beforebegin', newSubHeaderContainer);
			}
			// Move table search box into the table header
			const tableSearchBox = adminContent.querySelector('p.search-box');
			const tableNavigation = adminContent.querySelector('.tablenav.top .tablenav-pages');
			if (tableSearchBox && tableNavigation) {
				tableNavigation.appendChild(tableSearchBox);
				tableSearchBox.classList.add('patched-search-box');
			}
		}
	}

	// Make sure all admin notices are placed after our new header and subheader container.
	// Unfortunately WordPress moves admin notices around dynamically in the DOM with Javascript, because they can't handle their own messy HTML backend.
	// Therefor we need an observer to move everything back into place when WordPress has moved something.

	patchAdminNotices() {
		const adminContent = document.querySelector('#wpbody-content');
		if (adminContent) {
			let patchedSubheader = document.querySelector('.wp-patched-subheader') || document.querySelector('.wp-patched-header');
			// Function to move messages after new header containers
			const moveNotices = () => {
				const adminNotices = document.querySelectorAll('.notice');
				adminNotices.forEach(function (notice) {
					const currentParent = notice.parentElement;
					if (patchedSubheader && currentParent && !currentParent.classList.contains('wp-patched-subheader')) {
						patchedSubheader.insertAdjacentElement('afterend', notice);
					}
				});
			};
			// Initial move of notices
			moveNotices();
			// Observer for moving things back into place
			const noticeObserver = new MutationObserver(function (mutationList) {
				// Temporarily disconnect the observer to avoid infinite loops
				noticeObserver.disconnect();
				// Move notices again after any mutations
				moveNotices();
				// Reconnect the observer after moving notices
				noticeObserver.observe(adminContent, { childList: true, subtree: true });
			});
			// Start observing the admin content for changes
			noticeObserver.observe(adminContent, { childList: true, subtree: true });
		}
	}

	// Show the content of the admin pages after DOM changes are fully rendered.
	// We delay the rendering with a timeout and a CSS fade in effect (see styles).

	showContent() {
		setTimeout(function () {
			const adminContent = document.querySelector('#wpbody-content');
			const adminNotices = document.querySelectorAll('.notice'); // Select all notices
			adminContent.style.opacity = '1';
			adminNotices.forEach(function (notice) {
				notice.style.opacity = '1';
			});
		}, 100);
	}


	initRefreshCache() {
		document.getElementById('refresh-cache').addEventListener('click', (event) => {
			fetch(NSContext.site.restUrl + 'admin/transients/clean',
				{
					method: 'DELETE',
					headers: {'X-WP-Nonce': NSContext.nonce}
				})
				.then((response) => {
					return response.json();
				})
				.then((payload) => {
					if (payload.data.status === 400) {
						console.warn(payload.code + ': ' + payload.message);
					} else {
						console.log(payload.records + ' transients cleaned');
						location.reload();
					}
				})
				.catch((error) => {
					console.log(error);
				});
		});
	}

  getHomeUrl() {
    return NSContext.site.homeUrl;
  }


  getSiteUrl() {
    return NSContext.site.siteUrl;
  }


  getAjaxUrl() {
    return NSContext.site.ajaxUrl;
  }

  getRestUrl() {
    return NSContext.site.restUrl;
  }

  getThemeUrl(url) {
    if (url !== null) {
      return NSContext.theme.url + '/' + url;
    }
    return NSContext.theme.url;
  }


}

export default new Platform();
